import { PaymentMethod } from 'console/billing/types';
export const amounts = {
    step: 10,
    min: 1,
    max: 100000,
    default: 100,
};
const default_dialog_state = {
    amount: amounts.default,
    payment_method: PaymentMethod.yakassa,
    org_inn: '',
    org_title: '',
    org_address: '',
    error: null,
};
export function createDialogState(suggested_amount_x100, billing_settings, org_details) {
    return {
        amount: suggested_amount_x100 != null
            ? Math.max(amounts.min, suggested_amount_x100 / 100)
            : default_dialog_state.amount,
        payment_method: billing_settings.last_payment_method === PaymentMethod.invoice
            ? PaymentMethod.auto_invoice
            : billing_settings.last_payment_method ??
                default_dialog_state.payment_method,
        org_inn: org_details?.inn ?? default_dialog_state.org_inn,
        org_title: org_details?.title ?? default_dialog_state.org_title,
        org_address: org_details?.address ?? default_dialog_state.org_address,
        error: null,
    };
}
